import { noop } from '@proc7ts/primitives';
import { createServer, request, } from 'node:http';
import { promisify } from 'node:util';
import { httpListener } from '../http/http-listener.js';
import { readAll } from '../impl/read-all.js';
/**
 * Testing HTTP server and client.
 */
export class TestHttpServer {
    /**
     * Starts new test HTTP server and binds it ro random port ad localhost.
     *
     * @returns A promise resolved to started server.
     */
    static start() {
        return new TestHttpServer().#start();
    }
    /**
     * @internal
     */
    #listener;
    /**
     * @internal
     */
    #server;
    constructor() {
        this.#listener = noop;
    }
    /**
     * HTTP server instance.
     */
    get server() {
        return this.#server;
    }
    /**
     * An address the service is bound to.
     */
    get address() {
        return this.#server.address();
    }
    /**
     * Starts to handle incoming requests by the given request listener.
     *
     * @param listener - New HTTP request listener.
     *
     * @returns `this` instance.
     */
    listenBy(listener) {
        this.#listener = listener;
        return this;
    }
    handleBy(configOrHandler, optionalHandler) {
        return this.listenBy(httpListener(configOrHandler, optionalHandler));
    }
    /**
     * @internal
     */
    #start() {
        return new Promise((resolve, reject) => {
            const server = (this.#server = createServer((request, response) => this.#listener(request, response)));
            server.on('error', reject);
            server.on('listening', () => resolve(this));
            server.listen({ port: 0, host: '127.0.0.1' });
        });
    }
    /**
     * Posts the data to the test server.
     *
     * @param path - Request path.
     * @param body - Request body to post, or `undefined` to post nothing.
     * @param options - Request options. The default request method is `POST`.
     *
     * @returns A promise resolves to server response.
     */
    post(path, body, options) {
        return new Promise((resolve, reject) => {
            const req = request(`http://${this.address.address}:${this.address.port}${path}`, {
                method: 'POST',
                host: this.address.address,
                port: this.address.port,
                ...options,
            }, response => {
                const resp = response;
                resp.body = () => readAll(resp);
                resolve(resp);
            });
            req.on('close', reject);
            req.on('error', reject);
            req.end(body);
        });
    }
    /**
     * Requests the data from the test server.
     *
     * @param path - Request path.
     * @param options - Request options. The default request method is `GET`.
     *
     * @returns A promise resolves to server response.
     */
    get(path, options) {
        return this.post(path, undefined, { method: 'GET', ...options });
    }
    /**
     * Stops this server.
     *
     * @returns A promise resolved when the server is stopped.
     */
    stop() {
        return promisify(this.server.close.bind(this.server))();
    }
}
//# sourceMappingURL=test-http-server.js.map